import { Action, ViewCondition } from '../store/view/types';

/**
 * Evaluates the display conditions a view declares on one of its elements (an action button today).
 * Every condition must match (AND), no condition means always visible, and a model that is not
 * loaded yet hides the conditional element rather than flashing it.
 * Strict equality only: the view file declares booleans, numbers or strings.
 */
export function isVisibleWhen(
  model: any,
  conditions?: ViewCondition[],
): boolean {
  if (!conditions?.length) return true;

  return conditions.every(
    (condition) => model?.[condition.property] === condition.value,
  );
}

/**
 * Builds the routerLink of a Navigate action. The view declares a static route plus, optionally,
 * the name of the model property holding the id of the record to open (`idProperty`). The id is
 * appended as the last segment, like the grids do (`href-grid-component.ts`). No id, no model, or
 * a model that does not carry the property: the route alone is used.
 * An action with a `customParameter` already carries the id there (`@idProperty` placeholder, passed
 * as the RouterLink `info`, i.e. navigation state): its route stays as is (`/Crm/Leads/Create`, not
 * `/Create/123`).
 */
export function buildActionRouterLink(action: Action, model: any): any[] {
  const id =
    action.idProperty && !action.customParameter
      ? model?.[action.idProperty]
      : null;

  return id != null ? [action.route, id] : [action.route];
}
